import { render, staticRenderFns } from "./changeLang.vue?vue&type=template&id=bcc8fa9a&scoped=true"
import script from "./changeLang.vue?vue&type=script&lang=js"
export * from "./changeLang.vue?vue&type=script&lang=js"
import style0 from "./changeLang.vue?vue&type=style&index=0&id=bcc8fa9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc8fa9a",
  null
  
)

export default component.exports